import type { PostOfficeMessageType } from '@graphql/generated-base';
import { useTranslation } from '@shared/core';
import { useMemo } from 'react';

export const usePostOfficeDefaults = () => {
  const { t } = useTranslation('postOffice');
  const defaults = t('defaults');

  return useMemo(() => {
    return {
      generic: {
        subject: defaults.generic.subject(),
        message: defaults.generic.message(),
        includeAppInstructions: true,
        includeWebsiteDetails: true,
        salutation: defaults.generic.salutation(),
      },
      reminder: {
        subject: defaults.reminder.subject(),
        message: defaults.reminder.message(),
        includeAppInstructions: true,
        includeWebsiteDetails: true,
        salutation: defaults.reminder.salutation(),
      },
      thankyou: {
        subject: defaults.thankyou.subject(),
        message: defaults.thankyou.message(),
        includeAppInstructions: false,
        includeWebsiteDetails: false,
      },
      giftWrap: undefined,
      greetingCard: undefined,
    } as Record<
      PostOfficeMessageType,
      | {
          subject: string;
          message: string;
          includeAppInstructions: boolean;
          includeWebsiteDetails: boolean;
          salutation?: string;
        }
      | undefined
    >;
  }, [defaults]);
};
